import {Box,useToast, Select, Input, NumberInput,NumberInputField, InputGroup, InputRightElement,
     Tabs, TabList, Tab, TabPanels,TabPanel,FormControl, FormLabel, Button, ButtonGroup,
     TableContainer,Table,Thead, Tbody,Th,Tr,Td, Tooltip,Spacer, Divider, SkeletonCircle,SkeletonText,
     Modal,ModalContent,ModalHeader,ModalFooter,ModalBody} from '@chakra-ui/react';
import { useState, useEffect, useRef } from 'react';
import {getDokumentTip, getDolazakByMigracijaId} from '../../util/apiMigracija';
import { getGovScans,getGovScanResult, getGovScansByMigracijaId} from '../../util/apiGovScan';
import { getKnjige } from "../../util/apiKnjiga";
import { getPasmine } from "../../util/apiPasmina";
import { getZivBrRegex } from "../../util/apiUtil";
import { getLokacijeTovilistaOdjeljciByKnjigaid} from "../../util/apiLokacija";
import Dokument from '../custom/Dokument';
import {MdPerson, MdLocationOn, MdAdd,MdSaveAlt,MdCancel, MdOutlineDelete,MdOutlineDocumentScanner} from 'react-icons/md'
import {GiWeight} from 'react-icons/gi'
import {DeleteIcon} from '@chakra-ui/icons';
import OsobaSelect from '../osoba/OsobaSelect';
import { Govedo, DolazakData,userReadOnly } from '../../util/grunt';
import GovScanTable from '../govscan/GovScanTable';


export default function Dolazak({_canSave=true,dolazak_tip_sifra="DKUP", readonly,onClose,onSave,onDelete,newDolazak=true,dolazakMigracijaId=0,isMigracijaView=false,size='xs'}) {
    
    const [lokacijebyknjiga, setLokacijeByKnjiga] = useState([])
    const [dataisloading,setDataIsLoading]=useState(true);
    const [deletedata,setDeleteData]=useState(false);
    const [dolazak,setDolazak]=useState({zivbrpattern:"",dokumentTipovi:[],knjige:[],lokacije:[],pasmine:[],dolazakData:new DolazakData()})
    const [posjednik,setPosjednik]=useState({selectedPosjednik:{},selectPosjednik:false});
    const [govstate,setGovstate]=useState({goveda:[],govedoAdd:false,selectedGovEdit:false,zivbrIspravan:{zivbr:true,mzivbr:true,zivbrdupli:false},
        govedoForInsert:Govedo.emptyGovedo()})
    const [dolazaktipsifra,setDolazakTipSifra]=useState(dolazak_tip_sifra);
        
    
    const [ocrdata,setOcrData]=useState({isOcrDolazak:false,show:false,data:[],selectedGovScanId:[],model:"",fetchData:false});
    const knjigeRef=useRef(null);
    const govimeRef=useRef(null);
    const toast=useToast();

        useEffect(()=>{
            const fetchGovScanResult=async()=>{
                try {
                    const res=await getGovScanResult({_govscansid:ocrdata.selectedGovScanId})
                    if (res.status===200) {
                        //dodaj goveda
                        let _g;
                        const _ar=[];
                        for (let index = 0; index < res.res.length; index++) {
                            _g=Govedo.emptyGovedo();
                            _g.zivbr=res.res[index].zivbr;
                            _g.datrod=res.res[index].datrod;
                            _g.spol=res.res[index].spol;
                            _g.mzivbr=res.res[index].mzivbr;
                            _g.pasmina_sifra=res.res[index].pasmina_sifra;
                            _g.pasmina_naziv=res.res[index].pasmina_naziv;
                            _g.putnica_serbr=res.res[index].putnica_serbr;
                            //lokacija
                            //odjeljak_id
                            _g.odjeljak_id=-1;
                            _g.lokacija="";
                            _ar.push(_g);
                        }
                        //setGovstate({...govstate,goveda:_ar});
                        //setOcrData({...ocrdata,show:false,data:[],fetchData:false});
                        setGovstate(prev => ({...prev, goveda:_ar}));
                        setOcrData(prev => ({...prev, show:false, data:[], fetchData:false}));

                    } else {
                        throw new Error(res.message);
                    }
                } catch (error) {
                    toast({
                        title:"Greška kod dohvata podataka (skenirani dokumenti).",
                        status:"error",
                        description:error.message,
                        isClosable:true,
                        duration:2000,
                        position:"top-right",
                    });
                }
            }
            if (ocrdata.fetchData) {
                fetchGovScanResult();
            }
        },[ocrdata.fetchData, ocrdata.selectedGovScanId, toast])

        useEffect(()=>{
            const fetchOcrData=async()=>{
                try {
                    const res=await getGovScans(true);
                    
                    if (res.status===200) {
                        //dodati govscanid (ili više njih) od postojeće migracije
                        for (let i = 0; i < dolazak.dolazakData.govscansid.length; i++) {
                            res.res.push(dolazak.dolazakData.govscansid[i]);
                            
                        }
                        //setOcrData({...ocrdata,isOcrDolazak:true,data:res.res})
                        setOcrData(prev => ({...prev, isOcrDolazak:true, data:res.res}))
                    } else {
                        throw new Error(res.message);
                    }
                } catch (error) {
                    toast({
                        title:"Greška kod dohvata podataka (unos migracije).",
                        status:"error",
                        description:error.message,
                        isClosable:true,
                        duration:2000,
                        position:"top-right",
                    });
                }
            }

            if (ocrdata.show) {
                fetchOcrData();
            }
        },[ocrdata.show,dolazak.dolazakData.govscansid, toast])

    const fetchData=async()=>{
        try {
            
            const resDoc=await getDokumentTip();
            const resKnj=await getKnjige();
            const resPas=await getPasmine();
            //await fetchDataLokacijebyKnjiga();
            const resZivbrRegex=await getZivBrRegex();
            const _dokumenttipovi=resDoc.res.filter(item=>item.migracija_tip_sifra===dolazaktipsifra);
            if (resDoc.status===200 && resKnj.status===200 && resPas.status===200 & resZivbrRegex.status===200) {
                if (newDolazak) {
                    setDolazak({...dolazak,zivbrpattern:resZivbrRegex.res[0].zivbr_regex,dokumentTipovi:_dokumenttipovi,knjige:resKnj.res,pasmine:resPas.res,dolazakData:{...dolazak.dolazakData,knjiga_id:resKnj.res[0].id,lokacija:resKnj.res[0].lokacija, posjednik_naziv:resKnj.res[0].posjednik_naziv,vlasnik_naziv:resKnj.res[0].vlasnik_naziv,dokument_tip_id:_dokumenttipovi[0].dokument_tip_id,odjeljak_id:resKnj.res[0].odjeljak_id}});            
                } else {
                    if (dolazakMigracijaId!==0) {
                        const _r=await fetchDolazakDataForEdit();    
                        setDolazak({...dolazak,dolazakData:_r.dolazakData,zivbrpattern:resZivbrRegex.res[0].zivbr_regex,dokumentTipovi:_dokumenttipovi,knjige:resKnj.res,pasmine:resPas.res});            
                        setPosjednik({...posjednik,selectedPosjednik:_r.selectedPosjednik});
                        setGovstate({...govstate,goveda:_r.goveda});
                        if (_r.dolazakData.govscansid.length>0) {
                           /* const _ar=[];
                            _r.dolazakData.govscansid.map((item,index)=>{
                                _ar.push(item.id);
                            })*/
                           const _ar = _r.dolazakData.govscansid.map(item => item.id);
                            //const [ocrdata,setOcrData]=useState({isOcrDolazak:false,show:false,data:[],selectedGovScanId:[],model:"",fetchData:false});
                            setOcrData({...ocrdata,selectedGovScanId:_ar,isOcrDolazak:true});
                        }
                    }
                    
                
                    
                }
                
                
            } else {
                throw new Error(resDoc.message);
            }
            
        } catch (error) {
            toast({
                title:"Greška kod dohvata podataka (unos migracije).",
                status:"error",
                description:error.message,
                isClosable:true,
                duration:2000,
                position:"top-right",
            });
        } finally {
            setDataIsLoading(false);
        }
        
    }

    const fetchDolazakDataForEdit=async ()=>{
        if (dolazakMigracijaId!==0) {
            try {
                const res=await getDolazakByMigracijaId(dolazakMigracijaId);
                if (res.status===200 && res.res.length>0) {
                    const _brgrla=res.res.length;
                    let _govedo;
                    let goveda=[];
                    //dolazak
                    const _res={};
                    const _d=new DolazakData();
                    _d.knjiga_id=res.res[0].knjiga_id;
                    _d.datum=res.res[0].datum;
                    _d.ijr=res.res[0].ijr;
                    _d.dokument_tip_id=res.res[0].dokument_tip_id;
                    _d.dokument_broj=res.res[0].dokument_broj;
                    _d.lokacija=res.res[0].lokacija;
                    _d.posjednik_naziv=res.res[0].posjednik_naziv;
                    _d.vlasnik_naziv=res.res[0].vlasnik_naziv;
                    _d.uktezina=res.res[0].uktezina;
                    _d.brgrla=_brgrla;
                    _d.jibg=res.res[0].jibg;
                    _d.putnica_serbr=res.res[0].putnica_serbr;
                    //ako je dolazak temeljen na ocr-u
                    if (res.res[0].isocr) {
                        //dohvati govscanid za tu migracija_id
                        try {
                            const resGovScans=await getGovScansByMigracijaId(dolazakMigracijaId);
                            _d.govscansid=resGovScans.res;    
                        } catch (error) {
                            
                        }
                    } else {
                        _d.govscansid=[];
                    }
                    _res.dolazakData=_d;
                    //posjednik
                    const _p={};
                    _p.id=res.res[0].prijasnji_posjednik_id;
                    _p.sifra=res.res[0].prijasnji_posjednik_sifra;
                    _p.naziv=res.res[0].prijasnji_posjednik;
                    _p.mjesto=res.res[0].prijasnji_posjednik_mjesto;
                    _p.ulkbr=res.res[0].prijasnji_posjednik_ulkbr;
                    _p.drzava=res.res[0].prijasnji_posjednik_drzava;
                    _p.drzava_sifra=res.res[0].prijasnji_posjednik_drzava_sifra;
                    _p.pbr=res.res[0].prijasnji_posjednik_pbr;
                    _p.posta=res.res[0].prijasnji_posjednik_posta;
                    _p.postanaziv=res.res[0].prijasnji_posjednik_posta;
                    _p.adresa=_p.mjesto +', '+_p.ulkbr;
                    _res.selectedPosjednik=_p;
                    
                    //goveda
                    res.res.forEach((g)=>{
                        _govedo=new Govedo({govedo_id:g.govedo_id,zivbr:g.zivbr,ime:g.ime,datrod:g.datrod,spol:g.spol,mzivbr:g.mzivbr,ozivbr:g.ozivbr,odjeljak_id:g.odjeljak_id,rfid:g.rfid,pasmina_sifra:g.pasmina_sifra,pasmina_naziv:g.pasmina_naziv,putnica_serbr:g.putnica_serbr});
                        
                        goveda.push(_govedo);
                    })
                    _res.goveda=goveda;
                    //
                    setDolazakTipSifra(res.res[0].dolazak_tip_sifra);
                    return _res;
                    
                } else {
                    if (res.status===200 && res.res.length===0) {
                        throw new Error("Podaci migracije nisu dohvaćeni iz baze.");
                    } else {
                        throw new Error(res.message);
                    }
    
                    
                }
            } catch (error) {
                toast({
                    title:"Greška kod dohvata podataka (pregled migracije).",
                    status:"error",
                    description:error.message,
                    isClosable:true,
                    duration:2000,
                    position:"top-right",
                });
            }
        }
        
    }
    
   
    useEffect(() => {
        fetchData();
        // if (editDolazak) {
        //     fetchDolazakDataForEdit();
        // }
      
      if (knjigeRef.current) {
        knjigeRef.current.focus();  
      }
       // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    

     useEffect(() => {
         const fetchDataLokacijebyKnjiga=async()=>{
        try {
            const resLok=await getLokacijeTovilistaOdjeljciByKnjigaid(dolazak.dolazakData.knjiga_id);
            if (resLok.status===200 ) {
                setLokacijeByKnjiga(resLok.res);
                
            } else {
                throw new Error(resLok.message);
            }
        } catch (error) {
            toast({
                title:"Greška kod dohvata podataka (lokacija - knjiga).",
                status:"error",
                description:error.message,
                isClosable:true,
                duration:2000,
                position:"top-right",
            });
        }
    }
   
         fetchDataLokacijebyKnjiga();
        
       }, [dolazak.dolazakData.knjiga_id,toast])

    //   useEffect(() => {
    //     fetchDataLokacijebyKnjiga();
        
    //   }, [])
    const onKnjigaChange=(event)=>{
        const _knjiga=dolazak.knjige.filter(item=>item.id.toString()===event.target.value);
        if (_knjiga.length===1) {
            //setDolazak({...dolazak,selectedKnjiga:_knjiga[0]});
            setDolazak({...dolazak,dolazakData:{...dolazak.dolazakData,knjiga_id:event.target.value,lokacija:_knjiga[0].lokacija,
                odjeljak_id:_knjiga[0].odjeljak_id,posjednik_naziv:_knjiga[0].posjednik_naziv,vlasnik_naziv:_knjiga[0].vlasnik_naziv}})
        }
    }

    const onValueChange=(event)=>{
        switch (event.target.id.toLowerCase()) {
            case "idzivbr":
                //govstate.govedoForInsert.zivbr=event.target.value.toUpperCase();
                setGovstate({...govstate,govedoForInsert:{...govstate.govedoForInsert,zivbr:event.target.value.toUpperCase()}})
                break;
            case "idime":
                setGovstate({...govstate,govedoForInsert:{...govstate.govedoForInsert,ime:event.target.value}})
                break;
            case "idmzivbr":
                setGovstate({...govstate,govedoForInsert:{...govstate.govedoForInsert,mzivbr:event.target.value.toUpperCase()}})
                break;
            case "idozivbr":
                setGovstate({...govstate,govedoForInsert:{...govstate.govedoForInsert,ozivbr:event.target.value.toUpperCase()}})
                break;
            case "iddatrod":
                setGovstate({...govstate,govedoForInsert:{...govstate.govedoForInsert,datrod:event.target.value}})
                break;
            case "idjibg":
                setDolazak({...dolazak,dolazakData:{...dolazak.dolazakData,jibg:event.target.value.toUpperCase()}})
                break;
            case "iddatum":
                if (event.target.value!=="") {
                    const _d=new Date(event.target.value);
                    _d.setDate(_d.getDate()+1);
                    setDolazak({...dolazak,dolazakData:{...dolazak.dolazakData,datum:event.target.value,ijr:_d.toISOString().split("T")[0]}})    
                }
                break;
            case "idijr":
                setDolazak({...dolazak,dolazakData:{...dolazak.dolazakData,ijr:event.target.value}})
                break;
            case "iduktezina":
                setDolazak({...dolazak,dolazakData:{...dolazak.dolazakData,uktezina:event.target.value}})
                break;
            case "idrfid":
                setGovstate({...govstate,govedoForInsert:{...govstate.govedoForInsert,rfid:event.target.value}})
                break;
            case "idbrgrla":
                if (isNaN(event.target.value)) {
                    setDolazak({...dolazak,dolazakData:{...dolazak.dolazakData,brgrla:0}});    
                }
                else {
                    setDolazak({...dolazak,dolazakData:{...dolazak.dolazakData,brgrla:Number(event.target.value)}});
                }
                break;
            case "idbrputnice":
                setGovstate({...govstate,govedoForInsert:{...govstate.govedoForInsert,putnica_serbr:event.target.value.toUpperCase()}});
                break;
            default:
                break;
        }
    }
    const onGovedoOdjeljakChange=(event)=>{
        setGovstate({...govstate,govedoForInsert:{...govstate.govedoForInsert,odjeljak_id:event.target.value}});
    }
    const onGovedoSpolChange=(event)=>{
        setGovstate({...govstate,govedoForInsert:{...govstate.govedoForInsert,spol:event.target.value}});
    }
    const onGovedoPasminaChange=(event)=>{
        setGovstate({...govstate,govedoForInsert:{...govstate.govedoForInsert,pasmina_sifra:event.target.value,pasmina_naziv:event.target.selectedOptions[0].innerText}});
    }
    const showKnjige=()=>{
        
            return (
                <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w={'100%'}>
                    <Box display={'flex'} flexDir={'row'} gap={'0.5rem'} w={'100%'}>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size} size={size}>Knjiga (farma)</FormLabel>
                            <Select focusBorderColor='grunt2.400' size={size} isDisabled={readonly} variant={'filled'} maxLength={50} onChange={onKnjigaChange} ref={knjigeRef} id='slctKnjiga' value={dolazak.dolazakData.knjiga_id}>
                            {Array.isArray(dolazak.knjige)?dolazak.knjige.map((item,i)=>{
                                    return (<option key={i} value={item.id}>{item.naziv}</option>)
                            }):""}
                            </Select>
                        </Box>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>Lokacija</FormLabel>
                                <InputGroup size={size}>
                                    <InputRightElement pointerEvents={'none'} children={<MdLocationOn/>}/>
                                    <Input focusBorderColor='grunt2.400' size={size} tabIndex={-1} variant={'outline'} isReadOnly placeholder='Lokacija' value={dolazak.dolazakData.lokacija} display={'block'}/>
                                </InputGroup>
                        </Box>
                    </Box>
                    <Box display={'flex'} flexDir={'row'} gap={'0.5rem'} w={'100%'}>
                        <Box  w={'50%'}>
                            <FormLabel fontSize={size}>Posjednik</FormLabel>
                            <InputGroup size={size}>
                                <InputRightElement pointerEvents={'none'} children={<MdPerson/>}/>
                                <Input focusBorderColor='grunt2.400' tabIndex={-1} variant={'outline'} isReadOnly placeholder='Posjednik' value={dolazak.dolazakData.posjednik_naziv} display={'block'}/>
                            </InputGroup>
                        </Box>
                        
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>Vlasnik</FormLabel>
                            <InputGroup size={size}>
                                <InputRightElement pointerEvents={'none'} children={<MdPerson/>}/>
                                <Input focusBorderColor='grunt2.400' tabIndex={-1} variant={'outline'} isReadOnly placeholder='Vlasnik' value={dolazak.dolazakData.vlasnik_naziv} display={'block'}/>
                            </InputGroup>
                        </Box>
                    </Box>
                </Box>
            )
      
    }

    const numberInputChaged=(vStr,vNum)=>{
        setDolazak({...dolazak,dolazakData:{...dolazak.dolazakData,uktezina:vStr}})
    }
    const brGrlaInputChanged=(vStr,vNum)=>{
        setDolazak({...dolazak,dolazakData:{...dolazak.dolazakData,brgrla:vNum}})
    }
    const showTabDolazak=()=>{
        if (dataisloading) {
            return (

                <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
                    <SkeletonCircle size='10' />
                    <SkeletonText mt='4' noOfLines={10} spacing='4' skeletonHeight='2' />
                </Box>
            )
        } else {
        return (
            <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
        
        <Box display={'flex'} flexDir={'row'} gap={'0.2rem'}>
            {showKnjige()}
        </Box>
        <Box>
            <Dokument size={size} migracija_tip_sifra={dolazaktipsifra} dokumenti={dolazak.dokumentTipovi} defaultDokumentTipId={dolazak.dolazakData.dokument_tip_id} defaultDokumentBroj={dolazak.dolazakData.dokument_broj} onDokumentTipIdChange={onDokumentTipIdChanged} onDokumentBrChange={onDokumentBrChange}/>
        </Box>
        <Box display={'flex'} flexDir={'column'} w={'100%'} gap={'0.5rem'}>
            <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
            <Box w={'50%'}>
                <FormLabel fontSize={size}>Datum</FormLabel>
                <Input focusBorderColor='grunt2.400' id="idDatum" size="xs"  type="date" variant={'filled'}  display={'block'} value={dolazak.dolazakData.datum} onChange={onValueChange}/>
            </Box>
            <Box w={'50%'}>
                <FormLabel fontSize={size}>Isporučeno u jedinstveni registar</FormLabel>
                <Input focusBorderColor='grunt2.400' id="idIjr" size="xs"  type="date" variant={'filled'}  display={'block'} value={dolazak.dolazakData.ijr} onChange={onValueChange}/>
            </Box>
            </Box>
            <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
            <Box w={'50%'}>
                <FormLabel fontSize={size}>Broj grla u migraciji</FormLabel>
                    <InputGroup size={size}>
                        <NumberInput focusBorderColor='grunt2.400' isDisabled={dolazaktipsifra==="DTELJ"}  onChange={brGrlaInputChanged}  value={dolazak.dolazakData.brgrla} id="idbrgrla" defaultValue={1} min={0}  max={999999} precision={0} w={'100%'}>
                            <InputRightElement pointerEvents={'none'} fontSize='1.2rem' fontWeight={'bold'} children={"#"}/>            
                            <NumberInputField id="idbrgrla1" placeholder='Broj grla'  variant={'filled'}  display={'block'} />
                        </NumberInput>
                    </InputGroup>
            </Box>
            <Box w={'50%'}>
            <FormLabel fontSize={size}>Ukupna težina</FormLabel>
                    <InputGroup size={size}>
                    
                    <NumberInput focusBorderColor='grunt2.400' id="iduktezina" defaultValue={"0.00"} onChange={numberInputChaged}  value={dolazak.dolazakData.uktezina}  min={0}  max={999999} precision={2} w={'100%'}>
                        <InputRightElement pointerEvents={'none'} children={<GiWeight/>}/>            
                        <NumberInputField id="iduktezina1"  placeholder='Ukupna težina'   variant={'filled'}  display={'block'} />
                    </NumberInput>
            </InputGroup>
            </Box>
            </Box>
            <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
            <Box w={'50%'}>
                
            </Box>
            <Box w={'50%'}>
                <FormLabel fontSize={size}>Pojedinačna težina</FormLabel>
                    <InputGroup size={size}>
                    
                        <InputRightElement pointerEvents={'none'} children={<GiWeight/>}/>            
                        <Input focusBorderColor='grunt2.400' tabIndex={-1} variant={'outline'} isReadOnly placeholder='Pojedinačna težina' value={dolazak.dolazakData.brgrla===0?"0.00":(dolazak.dolazakData.uktezina/dolazak.dolazakData.brgrla).toFixed(2)} display={'block'}/>
                    
            </InputGroup>
            </Box>
            </Box>
        </Box>
       
    </Box>
        )
        }
    }
    const onDokumentTipIdChanged=(id)=>{
        setDolazak({...dolazak,dolazakData:{...dolazak.dolazakData,dokument_tip_id:id}})
    }

    const onDokumentBrChange=(br)=>{
        setDolazak({...dolazak,dolazakData:{...dolazak.dolazakData,dokument_broj:br}})
    }

    const onSelectPosjednik=(posjednik)=>{
        setPosjednik({...posjednik,selectedPosjednik:posjednik,selectPosjednik:false})
    }

    const showTabPosjednik=()=>{
        let __subjtipid="";
        let _naslov="";
        switch (dolazaktipsifra) {
            case "DKUP":
                __subjtipid="os";
                _naslov="Domaći partneri";
                break;
                case "DUVOZ":
                __subjtipid="so";
                _naslov="Strani partneri";
                    break;
            default:
                _naslov="Partneri";
                __subjtipid="";
                break;
        }
        
        if (dataisloading) {
            return (

                <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
                    <SkeletonCircle size='10' />
                    <SkeletonText mt='4' noOfLines={10} spacing='4' skeletonHeight='2' />
                </Box>
            )
        } else {
        if (posjednik.selectPosjednik) {
            return (<OsobaSelect onSelect={onSelectPosjednik} naslov={_naslov} subjekttipid={__subjtipid} drzavaFilter={ocrdata.model} onClose={()=>setPosjednik({...posjednik,selectPosjednik:false})}/>);    
        } else {
            return (
                <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
                    <Box mt={'0.5rem'}>
                        <Button isDisabled={readonly} rightIcon={<MdPerson/>} size={size} colorScheme={'grunt2'} variant={'outline'} onClick={()=>setPosjednik({...posjednik,selectPosjednik:true})}>Odaberi</Button>
                    </Box>
                    <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>Šifra</FormLabel>
                            <Input focusBorderColor='grunt2.400' isReadOnly tabIndex={-1} size={size} variant={'filled'}  display={'block'} value={posjednik.selectedPosjednik.sifra}/>
                        </Box>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>Naziv</FormLabel>
                            <Input focusBorderColor='grunt2.400' isReadOnly tabIndex={-1} size={size} variant={'filled'}  display={'block'} value={posjednik.selectedPosjednik.naziv}/>
                        </Box>
                    </Box>
                    <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>Mjesto</FormLabel>
                            <Input focusBorderColor='grunt2.400' isReadOnly tabIndex={-1} size={size} variant={'filled'} display={'block'} value={posjednik.selectedPosjednik.mjesto}/>
                        </Box>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>Ulica i kbr.</FormLabel>
                            <Input focusBorderColor='grunt2.400' isReadOnly tabIndex={-1} size={size} variant={'filled'} display={'block'} value={posjednik.selectedPosjednik.ulkbr}/>
                        </Box>
                    </Box>
                    <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>Pošta</FormLabel>
                            <Input focusBorderColor='grunt2.400' isReadOnly tabIndex={-1} size={size} variant={'filled'} display={'block'} value={posjednik.selectedPosjednik.posta}/>
                        </Box>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>Država</FormLabel>
                            <Input focusBorderColor='grunt2.400' isReadOnly tabIndex={-1} size={size} variant={'filled'} display={'block'} value={posjednik.selectedPosjednik.drzava}/>
                        </Box>
                    </Box>
                    <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>JIBG</FormLabel>
                            <Input focusBorderColor='grunt2.400' isReadOnly={readonly} maxLength={11} isDisabled={dolazaktipsifra==="DKUP"?false:true} id="idJIBG" size={size}  variant={'outline'}  display={'block'} value={dolazak.dolazakData.jibg} onChange={onValueChange}/>
                        </Box>
                        <Box w={'50%'}>
                            
                        </Box>
                    </Box>
                </Box>
            )
        }
        }
        

    }

const onTabIndexChange=(i)=>{
    if (i!==1) {
        setPosjednik({...posjednik,selectPosjednik:false});
    }
    if (i!==2) {
        setGovstate({...govstate,govedoAdd:false,selectedGovEdit:false});
    }
}

const setGovedoForEdit=(zivbr)=>{
    if (!readonly && !ocrdata.isOcrDolazak) {
        const _govedit=govstate.goveda.filter(gov=>gov.zivbr===zivbr);
    if (_govedit.length===1) {
        setGovstate({...govstate,govedoAdd:false,selectedGovEdit:true,govedoForInsert:_govedit[0],zivbrIspravan:{...govstate.zivbrIspravan,zivbr:true,mzivbr:true,zivbrdupli:false}});
    }    
    }
    
}
const govedaCanBeEdited = ()=>{
    if (!readonly && !ocrdata.isOcrDolazak) {
        return true;
    } else {
        return false;
    }

}
const newGovedo=()=>{
    
    
    const _g=Govedo.emptyGovedo();
    _g.odjeljak_id=dolazak.dolazakData.odjeljak_id;
    setGovstate({...govstate,govedoAdd:true,govedoForInsert:_g,zivbrIspravan:{...govstate.zivbrIspravan,zivbr:true,mzivbr:true,zivbrdupli:false}});

}

const addOcrData=()=>{
    setOcrData({...ocrdata,show:true})
}

/*const removeOcrData=()=>{
    setOcrData({...ocrdata,show:false,data:[]})
}*/


const onEnterPress=(event)=>{
    if (event.target.id==="idZivBr" && event.keyCode===13) {
        govimeRef.current.focus();
    }
}

const showButtonDodaj=()=>{
    //dolazak_tip_sifra
    let disabled=false;
    let ocrdisabled=false;
    if ((dolazaktipsifra==="DTELJ" && govstate.goveda.length===1) || readonly) {
        ocrdisabled=true;
    }
    if ((dolazaktipsifra==="DTELJ" && govstate.goveda.length===1) || readonly || ocrdata.isOcrDolazak || dolazak.dolazakData.govscansid.length>0) {
        disabled=true;    
    } 
    return (
        <>
            <Button mr={'2rem'} rightIcon={<MdAdd/>} size={size} colorScheme={'grunt2'} variant={'outline'} onClick={newGovedo} isDisabled={disabled}>Dodaj</Button>
            <Button rightIcon={<MdOutlineDocumentScanner/>} size={size} colorScheme={'grunt2'} variant={'outline'} isDisabled={dolazaktipsifra==="DUVOZ" || dolazaktipsifra==="DKUP"?ocrdisabled:true} onClick={addOcrData}>OCR</Button>
        </>
        )
}
    const showOcrTab=()=>{
        if (ocrdata.show) {
            return (
                <Box h={'50vh'}>
                <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%' h={'100%'}>
                    <GovScanTable data={ocrdata.data} pocetnirbr={0} mode={'select'} size='xs' onSelectGovScanId={addGovScanId} 
                    onDeselectGovScanId={removeGovScanId} modelFIlter={""} selectedGovScansId={ocrdata.selectedGovScanId} readonly={userReadOnly()}/>
                </Box>
                    <ButtonGroup>
                        <Button rightIcon={<MdSaveAlt/>} size={size} colorScheme={'grunt2'} variant={'solid'} onClick={applyGovScan}>Prihvati</Button>
                        <Button rightIcon={<MdCancel/>} size={size} colorScheme={'grunt2'} variant={'outline'} onClick={cancelGovScan}>Odustani</Button>
                    </ButtonGroup>
                </Box>
            )
        }
    }

    const addGovScanId=(govscanid,drzavafilter="")=>{
        //alert(govscanid);
        const d=[...ocrdata.selectedGovScanId];
        d.push(govscanid)
        setOcrData({...ocrdata,selectedGovScanId:d,model:drzavafilter})
    }

    const removeGovScanId=(govscanid)=>{
        const d=[...ocrdata.selectedGovScanId];
        const i=d.findIndex((item)=>item===govscanid);
        d.splice(i,1);
        if (d.length===0) {
            setOcrData({...ocrdata,selectedGovScanId:d,model:""})
        } else {
            setOcrData({...ocrdata,selectedGovScanId:d})
        }
    }

    const cancelGovScan=()=>{
        setOcrData({...ocrdata,show:false,data:[],model:""})
        //{show:false,data:[],selectedGovScanId:[],model:""}
    }

    const applyGovScan=()=>{
        setOcrData({...ocrdata,fetchData:true});
    }

    const showGovedaTab=()=>{
        if (!ocrdata.show) {
            if (dataisloading) {
                return (
    
                    <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
                        <SkeletonCircle size='10' />
                        <SkeletonText mt='4' noOfLines={10} spacing='4' skeletonHeight='2' />
                    </Box>
                )
            } else {
            return (
                
                <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
                    {(govstate.govedoAdd===false && govstate.selectedGovEdit===false) && 
                    <>
                        <Box mt={'0.5rem'}>
                            {showButtonDodaj()}   
                        </Box>
                        <TableContainer w={'100%'} h={'75vh'} overflowY={'auto'} >
                            <Table size={'xs'} >
                                <Thead _hover={{cursor:'pointer'}}>
                                    <Tr>
                                        
                                        <Th w={'5%'} fontSize={size} textAlign={'center'} zIndex='5' top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} borderTopLeftRadius={size}>Br.</Th>
                                        <Th w={'15%'} fontSize={size} textAlign={'center'} zIndex='5' top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Živ.br</Th>
                                        <Th w={'5%'} fontSize={size} textAlign={'center'} zIndex='5' top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Spol</Th>
                                        <Th w={'15%'} fontSize={size} textAlign={'center'} zIndex='5' top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Dat. rod.</Th>
                                        <Th w={'15%'} fontSize={size} textAlign={'center'} zIndex='5' top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>ŽB majke</Th>
                                        <Th w={'30%'} fontSize={size} textAlign={'center'} zIndex='5' top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Pasmina</Th>
                                        
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {govstate.goveda.map((item,index)=>{
                                        
                                            return (
                                                <Tr color={'grunt2'} key={item.zivbr}  bg={'white'} fontWeight={'normal'} 
                                                        _hover={{bg:'gray.100',cursor:govedaCanBeEdited()?'pointer':'text'}} h='2rem' onClick={(zivbr)=>setGovedoForEdit(item.zivbr)}>
                                                            <Td fontSize={size} textAlign={'center'}>{index+1}.</Td>
                                                            <Td fontSize={size} textAlign={'center'}>{item.zivbr}</Td>
                                                            <Td fontSize={size} textAlign={'center'}>{item.spol==="m"?"M":"Ž"}</Td>
                                                            <Td fontSize={size} textAlign={'center'}>{new Date(item.datrod).toLocaleDateString('hr-HR')}</Td>
                                                            <Td fontSize={size} textAlign={'center'}>{item.mzivbr}</Td>
                                                            <Td fontSize={'0.7rem'} textAlign={'center'}>{item.pasmina_naziv}</Td>
                                                        </Tr>
                                            )    
                                        
                                        
                                    })}
                                </Tbody>
                            </Table>
                        </TableContainer>
                        
                    </>
                    }
                    {(govstate.govedoAdd===true || govstate.selectedGovEdit===true) && 
                    <>
                   
                        <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                            <Box display={'flex'} flexDir={'column'} w={'50%'}>
                                <FormLabel fontSize={size}>Životni broj</FormLabel>
                                {/* isDisabled={govstate.zivbrIspravan.zivbr || !govstate.zivbrIspravan.zivbrdupli} */}
                                <Tooltip hasArrow label={!govstate.zivbrIspravan.zivbr?'Neispravan životni broj.':'Grlo je već uneseno'} bg='red' color='white' isDisabled={govstate.zivbrIspravan.zivbr && (govstate.zivbrIspravan.zivbrdupli===false)}>
                                    <Input focusBorderColor='grunt2.400' size={size} id='idZivBr' onKeyDown={onEnterPress} autoFocus isInvalid={!govstate.zivbrIspravan.zivbr || govstate.zivbrIspravan.zivbrdupli} variant={'filled'} maxLength={20} onChange={onValueChange} value={govstate.govedoForInsert.zivbr}></Input>
                                </Tooltip>
                            </Box>
                            <Box display={'flex'} flexDir={'column'} w={'50%'}>
                                <FormLabel fontSize={size}>Ime</FormLabel>
                                <Input focusBorderColor='grunt2.400' size={size} id='idIme' ref={govimeRef} variant={'filled'} onChange={onValueChange} maxLength={20} value={govstate.govedoForInsert.ime}></Input>
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                            <Box display={'flex'} flexDir={'column'} w={'50%'}>
                                <FormLabel fontSize={size}>Datum rođenja</FormLabel>
                                
                                <Input focusBorderColor='grunt2.400' size={size} id='iddatrod' variant={'filled'} type='date' maxLength={20} onChange={onValueChange} defaultValue={govstate.govedoForInsert.datrod}></Input>
                            </Box>
                            <Box display={'flex'} flexDir={'column'} w={'50%'}>
                                <FormLabel fontSize={size}>Spol</FormLabel>
                                <Select focusBorderColor='grunt2.400' size={size} variant={'filled'} defaultValue={govstate.govedoForInsert.spol} onChange={onGovedoSpolChange} id='slctSpol'>
                                    <option key={'idm'} value='m'>MUŠKO</option>
                                    <option key={'idf'} value='f'>ŽENSKO</option>
                                </Select>
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                            <Box display={'flex'} flexDir={'column'} w={'50%'}>
                                <FormLabel fontSize={size}>Životni broj majke</FormLabel>
                                <Tooltip hasArrow label='Neispravan životni broj majke.' bg='red' color='white'  isDisabled={govstate.zivbrIspravan.mzivbr}>
                                    <Input focusBorderColor='grunt2.400' size={size} id='idMZivBr' isInvalid={!govstate.zivbrIspravan.mzivbr} variant={'filled'} onChange={onValueChange} value={govstate.govedoForInsert.mzivbr} maxLength={20}></Input>
                                </Tooltip>
                            </Box>
                            <Box display={'flex'} flexDir={'column'} w={'50%'}>
                                <FormLabel fontSize={size}>Životni broj oca</FormLabel>
                                <Input focusBorderColor='grunt2.400' size={size} id='idOZivBr' variant={'filled'} onChange={onValueChange} value={govstate.govedoForInsert.ozivbr} maxLength={20}></Input>
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                            <Box display={'flex'} flexDir={'column'} w={'50%'}>
                                <FormLabel fontSize={size}>Pasmina</FormLabel>
                                <Select focusBorderColor='grunt2.400' size={size} variant={'filled'} defaultValue={'03'} onChange={onGovedoPasminaChange} id='slctPasm'>
                                    {
                                    dolazak.pasmine.map((item,i)=>{
                                        return (
                                            <option key={`psm${i}`} value={item.sifra}>{item.naziv}</option>        
                                        )
                                    })
                                    }
                                    
                                </Select>
                            </Box>
                            <Box display={'flex'} flexDir={'column'} w={'50%'}>
                                <FormLabel fontSize={size}>Lokacija</FormLabel>
                                    <Select focusBorderColor='grunt2.400' size={size} variant={'filled'} defaultValue={govstate.govedoAdd?dolazak.dolazakData.odjeljak_id:govstate.govedoForInsert.odjeljak_id} onChange={onGovedoOdjeljakChange} id='slctLok'>
                                        {
                                        lokacijebyknjiga.map((item,i)=>{
                                            return (
                                                <option key={`lok${i}`} value={item.odjeljak_id}>{item.lokacija_naziv}/{item.toviliste_naziv}/{item.odjeljak_naziv}</option>        
                                            )
                                        })
                                        }
                                        
                                    </Select>
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                            <Box display={'flex'} flexDir={'column'} w={'50%'}>
                                <FormLabel fontSize={size}>RFID</FormLabel>
                                <Input focusBorderColor='grunt2.400' size={size} id='idRfid' variant={'filled'} maxLength={20} onChange={onValueChange} value={govstate.govedoForInsert.rfid}></Input>
                            </Box>
                            <Box display={'flex'} flexDir={'column'} w={'50%'}>
                                <FormLabel fontSize={size}>Broj putnice</FormLabel>
                                <Input focusBorderColor='grunt2.400' size={size} id='idBrPutnice' variant={'filled'} maxLength={30} onChange={onValueChange} value={govstate.govedoForInsert.putnica_serbr}></Input>
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'} w={'50%'} gap={'0.5rem'}>
                        <Button rightIcon={<MdSaveAlt/>} size={size} colorScheme={'grunt2'} variant={'solid'} onClick={govedoInsert}>{govstate.govedoAdd?"Dodaj":"Prihvati"}</Button>
                        <Button rightIcon={<MdCancel/>} size={size} colorScheme={'grunt2'} variant={'outline'} onClick={()=>setGovstate({...govstate,govedoAdd:false,selectedGovEdit:false})}>Odustani</Button>
                        <Spacer/>
                        {govstate.selectedGovEdit &&
                        <Button rightIcon={<MdOutlineDelete/>} size={size} colorScheme={'red'} variant={'outline'} onClick={govedoRemove}>Briši</Button>
                        }
                        </Box>
                     
                    </>    
                    }
    
                </Box>
            )
                }    
        }
        
    }
    
    const validZivbr=(zivbrregex,zivbr)=>{
        
        const _r=new RegExp(zivbrregex);
        //return _r.test(govstate.govedoForInsert.zivbr);
        return _r.test(zivbr);
    }

    const govedoInsert=()=>{
        let _vzivbr=true;
        let _mvzivbr=true;
        let _vecunesenpodatak=-1;
        if (govstate.govedoAdd) {
            _vecunesenpodatak=govstate.goveda.findIndex(item=>item.zivbr===govstate.govedoForInsert.zivbr);//ako je -1 znači da nema tog zivbr u arrayu    
        }
        
   
        _vzivbr=validZivbr(dolazak.zivbrpattern,govstate.govedoForInsert.zivbr);
        _mvzivbr=validZivbr('^$|'+dolazak.zivbrpattern,govstate.govedoForInsert.mzivbr);
        
        if (_vzivbr && _mvzivbr && (_vecunesenpodatak===-1)) {
            const _goveda=govstate.goveda;
            if (govstate.govedoAdd) {
                _goveda.push(govstate.govedoForInsert);    
            } else if (govstate.selectedGovEdit) {
                const _index=_goveda.findIndex(gov=>gov.zivbr===govstate.govedoForInsert.zivbr);
                _goveda.splice(_index,1,govstate.govedoForInsert);
            }
            setGovstate({...govstate,goveda:_goveda,govedoAdd:false,selectedGovEdit:false, govedoForInsert:newGovedo()})    
        } else {
            
            setGovstate({...govstate,zivbrIspravan:{...govstate.zivbrIspravan,zivbr:_vzivbr,mzivbr:_mvzivbr,zivbrdupli:(_vecunesenpodatak!==-1)}});
            
        }
        
}

const deleteDolazak=()=>{
    onDelete(dolazakMigracijaId);
    setDeleteData(false);

}

const potvrdiBrisanje=()=>{
    if (deletedata) {
        return (
            <>
        <Modal isOpen={true} size={size}>
        
        <ModalContent>
          <ModalHeader color={'grunt2'}>Grunt.RGG</ModalHeader>
          
          <ModalBody>
            Jeste li sigurni da želite obrisati podatke dolaska?
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='grunt2' variant={'solid'} mr={3} size={size} onClick={deleteDolazak}>
              Da
            </Button>
            <Button colorScheme='grunt2' variant={'outline'} mr={3} size={size} onClick={()=>{setDeleteData(false)}}>
              Ne
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
            </>
        )
    }
  }     
const govedoRemove=()=>{
    if (govstate.selectedGovEdit) {
        const _goveda=govstate.goveda;
        const _index=_goveda.findIndex(gov=>gov.zivbr===govstate.govedoForInsert.zivbr);
        _goveda.splice(_index,1);
        setGovstate({...govstate,goveda:_goveda,govedoAdd:false,selectedGovEdit:false})
    }
}

const saveDolazak=()=>{
    //dokumenttipid,migracijatipsifra,knjigaid,datum,posjednikid,tezina,ijr,dokumentbroj,goveda=[]
    //zivbr="",ime="",datrod, spol,mzivbr,ozivbr,odjeljak_id=0,rfid,pasmina_sifra,pasmina_naziv="OSTALI KRIŽANCI"
    const data={dokumenttipid:dolazak.dolazakData.dokument_tip_id,migracijatipsifra:dolazaktipsifra,
    knjigaid:dolazak.dolazakData.knjiga_id,datum:dolazak.dolazakData.datum,
    posjednikid:dolazaktipsifra==="DTELJ"?0:posjednik.selectedPosjednik.id,
    uktezina:dolazak.dolazakData.uktezina,ijr:dolazak.dolazakData.ijr,dokumentbroj:dolazak.dolazakData.dokument_broj,
    goveda:[],govscansid:ocrdata.selectedGovScanId,jibg:dolazak.dolazakData.jibg};
    for (const g of govstate.goveda){
        if (g.odjeljak_id<=0) {//kod OCR dolaska grla nemaju dodijeljen odjeljak_id pa im dajemo odjeljak_id od farme/knjige
            g.odjeljak_id=dolazak.dolazakData.odjeljak_id;
        }
        data.goveda.push({zivbr:g.zivbr,datum_rodjenje:g.datrod,spol:g.spol,pasmina_sifra:g.pasmina_sifra,mzivbr:g.mzivbr,ozivbr:g.ozivbr,rfid:g.rfid,odjeljakid:g.odjeljak_id,putnica_serbr:g.putnica_serbr});
    }
    //
    onSave(data);

}

const canSaveData=()=>{
    if (_canSave===false || readonly || govstate.goveda.length===0 ||(govstate.goveda.length!==dolazak.dolazakData.brgrla) || (JSON.stringify(posjednik.selectedPosjednik)==="{}" && dolazaktipsifra!=="DTELJ") ) {
        return false;
    } else {
        return true;
    }
}


  return (
    
    <FormControl>
        
    <Tabs variant='enclosed' onChange={onTabIndexChange} overflow={'auto'} minH={'70vh'} h={'100%'} colorScheme='grunt2' size={'sm'}>
        <TabList>
            <Tab _focus={{fontWeight:'bold'}}>Dolazak</Tab>
            <Tab _focus={{fontWeight:'bold'}} isDisabled={dolazaktipsifra==="DTELJ"}>Prijašnji posjednik</Tab>
            {userReadOnly()?null:<Tab _focus={{fontWeight:'bold'}}>Goveda</Tab>}
            
            
        </TabList>
        <TabPanels>
            <TabPanel>
            
            {showTabDolazak()}
            {potvrdiBrisanje()}
            </TabPanel>
            <TabPanel>
                {dolazaktipsifra==="DTELJ"?<></>:showTabPosjednik()}
            </TabPanel>
           
            <TabPanel>
                    {showGovedaTab()}
                    {showOcrTab()}
            </TabPanel>
            
        </TabPanels>
    </Tabs>
    <Divider orientation='horizontal'/>
    {isMigracijaView?<></>:
    <Box display={'flex'} flexDir={'row'} m={'1rem'} w='100%'>
        <ButtonGroup gap={'1rem'} mr={'10rem'}>
            
            <Button isDisabled={!canSaveData()} rightIcon={<MdSaveAlt/>} type={'submit'} colorScheme={'grunt2'} size={size} onClick={saveDolazak} >Spremi</Button>
            <Button colorScheme={'grunt2'} rightIcon={<MdCancel/>} variant={'outline'} size={size} onClick={onClose}>Odustani</Button>
            
            
        </ButtonGroup>
        <Button isDisabled={readonly} hidden={newDolazak}  colorScheme={'red'} rightIcon={<DeleteIcon/>} variant={'outline'} size={size} onClick={()=>{setDeleteData(true)}}>Briši</Button>    
    </Box>
    }
    </FormControl>
    
  )
  
}
